import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36607c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "chats"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { id: "bottom" }
const _hoisted_5 = {
  key: 0,
  class: "money"
}
const _hoisted_6 = { id: "main" }
const _hoisted_7 = { class: "img" }
const _hoisted_8 = {
  key: 0,
  class: "system"
}
const _hoisted_9 = {
  key: 1,
  class: "user"
}
const _hoisted_10 = {
  key: 2,
  class: "ai"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  id: "stretch"
}
const _hoisted_13 = {
  key: 1,
  id: "home"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "🙂千禧GPT使用规范，恳请大家遵守"),
  /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, [
    /*#__PURE__*/_createElementVNode("ol", null, [
      /*#__PURE__*/_createElementVNode("li", null, "请遵纪守法，不要输入不好的言语"),
      /*#__PURE__*/_createElementVNode("li", null, "请勿输入涉及到个人隐私的信息，以防泄密"),
      /*#__PURE__*/_createElementVNode("li", null, "如果Key失效，请清理浏览器缓存后点击左侧的重置配置菜单")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, " 如果您有自己的OpenAI API Key，可以点击左侧打开配置菜单，输入自己的Key使用 ")
  ])
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  id: "input"
}
const _hoisted_17 = { class: "textarea" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请在下方输入你的 key", -1))
const _hoisted_19 = ["onKeydown"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "key 会保存在本地浏览器(localStorage)中，只供本地使用", -1))
const _hoisted_21 = { class: "panel" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "key：", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "行为设定：", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("span", null, "给 OpenAI 设定一个行为，比如："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "“你是一直猫，每句话后面加个 喵~”")
], -1))

import { ref, reactive, onMounted, nextTick, watch, withCtx } from "vue";
    import axios from "axios";
    import DialogCom from "@/components/dialogCom.vue";
    import messageUtil from "@/utils/messageUtil";
    import hljs from "highlight.js";
    import Clipboard from "clipboard";
    import Viewer from "viewerjs";
    import "viewerjs/dist/viewer.css";
    import themeUtil from "@/utils/themeUtil";
    import cacheUtil from "@/utils/cacheUtil";
    import MarkdownIt from "markdown-it";
    import mk from "@iktakahiro/markdown-it-katex";
    import pdfUtil from "@/utils/pdf";

    interface IMessage {
        role: "user" | "assistant" | "system";
        content: string;
        tokens: number;
        stream: string;
    }

    // 回话列表
    interface IClient {
        name: string;
        contents: Array<IMessage>;
        exceedTokens: number;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const md = new MarkdownIt();
    md.use(mk);

    const { config, read, save } = cacheUtil;

    // 读取配置
    read();

    // 输入 key dialog
    const okKeyDialog = ref(config.key == "");

    // 获取聊天窗口 dom
    let messageDom: Element | null = null;
    // Viewer
    let viewer: any = null;

    onMounted(() => {
        viewer = new Viewer(document.querySelector("#main") as HTMLElement);
        messageDom = document.querySelector("#messages");
        themeUtil.load();

        if (config.key) {
            // getMoney();
        }
        // newBing();
    });

    /**
     * 确认 key
     */
    const confirmKey = ref("");

    function okKey() {
        if (confirmKey.value == "") {
            return messageUtil({
                type: "warning",
                content: "key 不能为空"
            });
        }

        config.key = confirmKey.value;
        confirmKey.value = "";
        save();

        okKeyDialog.value = false;
        messageUtil({
            type: "success",
            content: "key 存储成功，开始提问吧"
        });

        // getMoney();
    }

    // 是否正在加载
    const loading = ref(false);

    /**
     * 提交问题
     */
    async function submit() {
        loading.value = true;
        const clientCache = clients[clientsIndex.value].contents;
        const lastClientCache = clientCache[clientCache.length - 1];
        if (lastClientCache.role != "assistant") pushResult("assistant", "");

        let cacheSystemClient: IMessage | null = null;
        if (clientCache[0].role == "system") {
            cacheSystemClient = clientCache[0];
        }
        const messages = clientCache.slice(
            clients[clientsIndex.value].exceedTokens * 2
        );
        if (cacheSystemClient) {
            messages.unshift(cacheSystemClient);
        }

        fetch(config.proxyHttp + "/v1/chat/completions", {
            method: "POST",
            body: JSON.stringify({
                // key: config.key,
                stream: true,
                model: config.data.model,
                messages: messages.map((item) => {
                    // HACK 过滤掉前几个聊天会话
                    return {
                        role: item.role,
                        content: item.stream
                    };
                }),
                max_tokens: 2000
            }),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${config.key}`
            }
        })
            .then((res: any) => {
                const reader = res.body.getReader();
                const decoder = new TextDecoder("utf-8");
                let streamCache = "";

                reader.read().then(async function processText(res: any) {
                    if (res.done || !loading.value) {
                        return;
                    }

                    const decodeContent = decoder.decode(res.value);

                    // error
                    if (decodeContent.includes(`"error": {\n`)) {
                        loading.value = false;
                        return errorHandle(decodeContent);
                    }

                    // done
                    if (decodeContent.includes("data: [DONE]")) {
                        loading.value = false;
                        const client =
                            clients[clientsIndex.value].contents[
                                clients[clientsIndex.value].contents.length - 1
                            ];
                        client.tokens = await computedToken(client.content);

                        saveMessage();
                        await nextTick();
                        hljsInit();
                        viewer.update();
                        return;
                    }

                    decodeContent
                        .replaceAll("data: ", "")
                        .split("\n")
                        .filter(Boolean)
                        .forEach(async (item: string) => {
                            const itemObj = JSON.parse(item);
                            if (!itemObj.choices[0].delta.content) {
                                return;
                            }

                            const str = itemObj.choices[0].delta.content;

                            streamCache += str;

                            clients[clientsIndex.value].contents[
                                clients[clientsIndex.value].contents.length - 1
                            ].content = md.render(streamCache);
                            clients[clientsIndex.value].contents[
                                clients[clientsIndex.value].contents.length - 1
                            ].stream = streamCache;
                            await nextTick();
                            hljsInit();
                        });

                    return reader.read().then(processText);
                });
            })
            .catch(() => {
                clients[clientsIndex.value].contents[
                    clients[clientsIndex.value].contents.length - 1
                ].content =
                    "<p>发起网络请求失败，服务器可能正在维护中，请稍后重试</p>";
                messageUtil({
                    type: "danger",
                    content: "发起网络请求失败，请稍后重试"
                });
                saveMessage();
                loading.value = false;
            });
    }

    /**
     * 存入数据
     */
    async function pushResult(
        role: "user" | "assistant" | "system",
        content: string,
        errContent?: string
    ) {
        const resultContent = errContent ? errContent : content;
        const contentData = {
            role,
            content: resultContent,
            tokens: 0,
            stream: resultContent
        };
        clients[clientsIndex.value].contents.push(contentData);
        contentData.tokens = await computedToken(contentData.stream);
        saveMessage();
        await nextTick();
        hljsInit();
        viewer.update();
    }

    /**
     * 保存会话
     */
    function saveMessage() {
        window.localStorage.setItem("message-data", JSON.stringify(clients));
        tokensCount();
    }

    // 消息框内容
    const message = ref("");

    /**
     * 发送消息
     */
    function send() {
        if (message.value == "" || message.value.trim() == "" || loading.value) {
            return;
        }

        // 没有对话时
        if (clientsIndex.value == -1) {
            clients.unshift({
                name: "",
                contents: [],
                exceedTokens: 0
            });
            clientsIndex.value = 0;
        }

        // 是否设置了行为
        if (config.system && clients[clientsIndex.value].contents.length == 0) {
            pushResult("system", md.render(config.system));
        }

        pushResult("user", md.render(message.value));

        // 第一句对话修改标题
        if (
            clients[clientsIndex.value].contents.length == 1 ||
            (clients[clientsIndex.value].contents[0].role == "system" &&
                clients[clientsIndex.value].contents.length == 2)
        ) {
            const cacheName = message.value;
            let num = 1;
            clients.forEach((item) => {
                if (item.name.indexOf(cacheName) == 0) {
                    num++;
                }
            });
            clients[clientsIndex.value].name =
                cacheName + (num == 1 ? "" : ` #${num}`);
            document.title = cacheName + " | ChatGPT";
        }

        // 清空输入框
        message.value = "";

        submit();
    }

    /**
     * 滚动到底部
     */
    let scrollLock = false;

    function scrollToBottom() {
        if (scrollLock) {
            return;
        }
        scrollLock = true;
        setTimeout(() => {
            scrollLock = false;
            messageDom = document.querySelector("#messages");
            if (messageDom) {
                // const childrens = messageDom.children;
                // let height = 0;
                // if (childrens[childrens.length - 1]) {
                //     height += childrens[childrens.length - 1].clientHeight;
                // }
                // if (childrens[childrens.length - 2]) {
                //     height += childrens[childrens.length - 2].clientHeight;
                // }
                messageDom.scrollTo({
                    top: messageDom.scrollHeight,
                    behavior: "smooth"
                });
            } else {
                scrollToBottom();
            }
        }, 300);
    }

    // shift 是否按住
    let shiftDown = false;

    /**
     * 消息框键盘按下
     */
    function keydown(event: KeyboardEvent) {
        // shift 是否按下
        if (event.keyCode === 16) {
            shiftDown = true;
        }
        // shift 不按住与 enter 按下，则发送
        if (!shiftDown && event.keyCode === 13) {
            send();
            event.preventDefault();
            return false;
        }
    }

    /**
     * 消息框键盘抬起
     */
    function keyup(event: KeyboardEvent) {
        // shift 是否取消按下
        if (event.keyCode === 16) {
            shiftDown = false;
        }
    }

    // 消息框高度
    const textareaHeight = ref(24);

    // 监听消息框内容变化改变高度
    watch(
        () => message.value,
        () => {
            // 根据换行符计算高度
            const lines = message.value.split("\n").length;
            textareaHeight.value = lines * 24;
        }
    );

    // 消息列表
    const cacheClients = window.localStorage.getItem("message-data");
    const clients: Array<IClient> = reactive(
        cacheClients ? JSON.parse(cacheClients) : []
    );
    const clientsIndex = ref(-1);

    // 会话索引切换
    watch(
        () => clientsIndex.value,
        async () => {
            if (clients[clientsIndex.value]) {
                document.title = clients[clientsIndex.value].name + " | 🤪ChatGPT";
                await nextTick();
                tokensCount();
                hljsInit();
                viewer.update();
                // MathJax.TypeSet();
            }
        }
    );

    /**
     * 创建新会话
     */
    function newClient() {
        saveMessage();
        let num = 1;
        clients.forEach((item) => {
            if (item.name.indexOf("新会话") == 0) {
                num++;
            }
        });
        clients.unshift({
            name: "新会话" + (num == 1 ? "" : ` #${num}`),
            contents: [],
            exceedTokens: 0
        });
        message.value = "";
        clientsIndex.value = 0;
    }

    /**
     * 删除会话
     */
    function removeClient(i: number) {
        // 删除会话
        document.title = "🤪ChatGPT";
        clients.splice(i, 1);
        clientsIndex.value = -1;
        saveMessage();
    }

    /**
     * 代码高亮
     */
    async function hljsInit() {
        const dom: any = [];
        const codeBlocks = document.querySelectorAll("#messages pre code");
        codeBlocks.forEach((cache) => {
            const item = cache as HTMLElement;
            if (item.getAttribute("class")?.includes("hljs")) {
                return;
            }
            const copyBtn = document.createElement("div");
            copyBtn.className = "copyBtn";
            copyBtn.innerHTML = "复制";
            copyBtn.setAttribute("code", item.innerText);
            copyBtn.addEventListener("click", (e) => {
                copyCode(e);
            });
            item.parentElement?.appendChild(copyBtn);
            hljs.highlightElement(item as HTMLElement);
            dom.push(item);
        });
        addCodeNum(dom);
        scrollToBottom();
    }

    /**
     * 添加代码行号
     */
    function addCodeNum(dom: any) {
        for (let i = 0; i < dom.length; i++) {
            const enter = dom[i].innerHTML.replace(/\n/g, "</li><li>");
            dom[i].innerHTML = `<ol><li>${enter}</li></ol>`.replace(
                "<li></li></ol>",
                "</ol>"
            );
        }
    }

    // 侧边栏显示
    const sideBarShow = ref(false);

    /**
     * 复制代码块
     */
    function copyCode(el: MouseEvent) {
        const code = (el.target as HTMLElement).getAttribute("code");
        if (code) {
            Clipboard.copy(code);
            messageUtil({
                type: "success",
                content: "复制成功"
            });
        }
    }

    /**
     * 重置配置
     */
    function reloadConfig() {
        window.localStorage.removeItem("message-data");
        window.localStorage.removeItem("n0ts-chatgpt-theme");
        window.localStorage.removeItem("n0ts-chatgpt-config");
        window.location.reload();
    }

    // 设置显示
    const settingShow = ref(false);

    /**
     * 确认设定
     */
    function toggleSetting() {
        settingShow.value = !settingShow.value;
        save();
        messageUtil({
            type: "success",
            content: "设置已保存"
        });
    }

    /**
     * 获取余额
     */
    const moneyData: any = ref(null);

    async function getMoney() {
        const { data } = await axios({
            method: "post",
            url: config.proxyHttp + "/quotas",
            data: {
                method: "GET",
                url: "https://api.openai.com/dashboard/billing/credit_grants",
                headers: {
                    authorization: `Bearer ${config.key}`
                }
            }
        });
        moneyData.value = data.data;
    }

    /**
     * 保留两位
     */
    function moneyToFixed(num: any, fixed: number) {
        return Number(num.toFixed(fixed));
    }

    /**
     * 错误处理
     */
    function errorHandle(error: string) {
        const errorObj = JSON.parse(
            error.replace("未知错误，请联系站长解决！", "")
        );
        console.error("报错了哥们", errorObj);

        if (errorObj.error.code == "invalid_api_key") {
            messageUtil({
                type: "danger",
                content: "API Key 错误，请重新配置"
            });
            config.key = "";
            save();
            okKeyDialog.value = true;
            return;
        } else if (errorObj.error.code == "context_length_exceeded") {
            // messageUtil({
            //     type: "danger",
            //     content: "会话内容已超出，已自动开启优化"
            // });
            clients[clientsIndex.value].exceedTokens += 1;
            return submit();
        }

        clients[clientsIndex.value].contents[
            clients[clientsIndex.value].contents.length - 1
        ].content = error;
    }

    /**
     * token 计算
     */
    async function computedToken(content: string) {
        return 0;
        // if (!content) {
        //     return 0;
        // }
        // const { data } = await axios({
        //     method: "GET",
        //     url: "https://api.n0ts.top/chatgpt/encoder",
        //     params: {
        //         content
        //     }
        // });
        // if (data.status == 400) {
        //     return 0;
        // }
        // return data.data.tokens / 2;
    }

    /**
     * tokens 总和
     */
    const tokensCountNum = ref(0);

    function tokensCount() {
        if (!clients[clientsIndex.value]) {
            return;
        }
        let count = 0;
        clients[clientsIndex.value].contents.forEach((item) => {
            count += item.tokens;
        });
        tokensCountNum.value = count;
    }

    /**
     * 暂停会话
     */
    function stopMessage() {
        loading.value = false;
    }

    /**
     * 导出 pdf
     */
    const exportLoading = ref(false);
    async function exportPdf() {
        exportLoading.value = true;
        await nextTick();
        await pdfUtil(
            "ChatGPT 对话导出 | " +
                new Date().toLocaleDateString().replaceAll("/", "-").toString(),
            "#main"
        );
        messageUtil({
            type: "success",
            content: "正在导出中，耐心稍等一会~"
        });
        exportLoading.value = false;
    }

    async function newBing() {
        const a = "\x1E";

        let { data: ids } = await axios.get("https://api.n0ts.top/bing/new");
        ids = ids.data;

        const ws = new WebSocket("wss://sydney.bing.com/sydney/ChatHub");

        const result: any = [];

        ws.onopen = () => {
            console.log("ws open");
            ws.send(JSON.stringify({ protocol: "json", version: 1 }) + a);
            ws.send(JSON.stringify({ type: 6 }) + a);
            ws.send(
                JSON.stringify({
                    arguments: [
                        {
                            source: "cib",
                            allowedMessageTypes: [
                                "Chat",
                                "InternalSearchQuery",
                                "InternalSearchResult",
                                "Disengaged",
                                "InternalLoaderMessage",
                                "RenderCardRequest",
                                "AdsQuery",
                                "SemanticSerp",
                                "GenerateContentQuery",
                                "SearchQuery"
                            ],
                            isStartOfSession: true,
                            verbosity: "verbose",
                            message: {
                                locale: "zh-CN",
                                market: "zh-CN",
                                region: "US",
                                author: "user",
                                inputMethod: "Keyboard",
                                text: "你好呀",
                                messageType: "Chat"
                            },
                            conversationSignature: ids.conversationSignature,
                            participant: {
                                id: ids.clientId
                            },
                            conversationId: ids.conversationId
                        }
                    ],
                    invocationId: "1",
                    target: "chat",
                    type: 4
                }) + a
            );
        };

        ws.onmessage = (e: MessageEvent) => {
            // type：1 消息
            e.data
                .split(a)
                .filter(Boolean)
                .forEach((str: any) => {
                    const r = JSON.parse(str);
                    result.push(r);
                    try {
                        if (r.arguments[0].messages[0].text) {
                            console.log(r.type, r.arguments[0].messages[0].text);
                        } else {
                            console.log(r.arguments[0].messages[0]);
                        }
                    } catch {
                        console.log(r);
                    }
                });
        };

        ws.onclose = () => {
            console.log("ws close");
        };
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "chatgpt",
      class: _normalizeClass({ print: exportLoading.value })
    }, [
      (!exportLoading.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "sidebar",
            class: _normalizeClass({ sideBarShow: sideBarShow.value })
          }, [
            _createElementVNode("div", { class: "btns" }, [
              _createElementVNode("div", {
                class: "btn",
                onClick: newClient
              }, "➕ 新建会话")
            ]),
            (!exportLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      onClick: ($event: any) => (clientsIndex.value = index),
                      class: _normalizeClass({ active: clientsIndex.value == index })
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.name), 1),
                      _createElementVNode("span", {
                        onClick: _withModifiers(($event: any) => (removeClient(index)), ["stop"])
                      }, "🗑 删除", 8, _hoisted_3)
                    ], 10, _hoisted_2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(themeUtil).switchTheme && _unref(themeUtil).switchTheme(...args)))
              }, _toDisplayString(_unref(themeUtil).themeCache.value == "light"
                    ? "🌞 暗色模式"
                    : "🌛 亮色模式"), 1),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (settingShow.value = true))
              }, "🎡 打开配置"),
              _createElementVNode("div", {
                class: "btn",
                onClick: reloadConfig
              }, "🎆重置配置"),
              (moneyData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 余额：" + _toDisplayString(moneyToFixed(moneyData.value.total_available, 2)) + " $，已用：" + _toDisplayString(moneyToFixed(moneyData.value.total_used, 2)) + " $ ", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              id: "showBtn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sideBarShow.value = !sideBarShow.value))
            }, _toDisplayString(sideBarShow.value ? "👈" : "👉"), 1)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (clients[clientsIndex.value])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "messages",
              class: _normalizeClass({ print: exportLoading.value })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients[clientsIndex.value].contents, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(item.role == 'user' ? 'right' : 'left')
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (item.role == 'system')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "SY"))
                      : (item.role == 'user')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Me"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, "AI"))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["content", {
                            end:
                                !loading.value ||
                                index !=
                                    clients[clientsIndex.value].contents.length - 1
                        }]),
                    innerHTML: item.content
                  }, null, 10, _hoisted_11)
                ], 2))
              }), 128)),
              (!exportLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)),
        (!exportLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass(["stop", { stopShow: loading.value }]),
                onClick: stopMessage
              }, "停止回复 🛑", 2),
              _createElementVNode("div", { class: "toolbar" }, [
                _createElementVNode("div", {
                  class: "icon-btn",
                  onClick: exportPdf
                }, "📜")
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((message).value = $event)),
                  onKeydown: keydown,
                  onKeyup: keyup,
                  style: _normalizeStyle({ height: textareaHeight.value + 'px' })
                }, null, 36), [
                  [_vModelText, message.value]
                ]),
                _createElementVNode("div", {
                  class: "btn",
                  id: "submit-btn",
                  onClick: send
                }, "发送")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(DialogCom, {
      title: "输入 key",
      show: okKeyDialog.value
    }, {
      center: _withCtx(() => [
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmKey).value = $event)),
          onKeydown: _withKeys(okKey, ["enter"])
        }, null, 40, _hoisted_19), [
          [_vModelText, confirmKey.value]
        ]),
        _hoisted_20
      ]),
      bottom: _withCtx(() => [
        _createElementVNode("button", {
          class: "success",
          onClick: okKey
        }, "提交")
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(DialogCom, {
      title: "设置",
      show: settingShow.value
    }, {
      center: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", null, [
            _hoisted_22,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(config).key) = $event))
            }, null, 512), [
              [_vModelText, _unref(config).key]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_23,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(config).system) = $event))
            }, null, 512), [
              [_vModelText, _unref(config).system]
            ])
          ]),
          _hoisted_24
        ])
      ]),
      bottom: _withCtx(() => [
        _createElementVNode("button", {
          class: "success",
          onClick: toggleSetting
        }, "保存"),
        _createElementVNode("button", {
          class: "info",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (settingShow.value = !settingShow.value))
        }, "关闭")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})